import React from "react";
var summaryFromIdsByCPI = function(idsByCPI, summaryText) {
    return Object.keys(idsByCPI).map(function(key) {
        var count = idsByCPI[key].length;
        return /*#__PURE__*/ React.createElement("li", {
            key: "".concat(key, "-").concat(summaryText)
        }, /*#__PURE__*/ React.createElement("span", null, count, " ", summaryText, " $", parseFloat(key).toFixed(2)));
    });
};
export var Summary = function(param) {
    var _param_cpi = param.cpi, cpi = _param_cpi === void 0 ? 0.0 : _param_cpi, _param_avgCPI = param.avgCPI, avgCPI = _param_avgCPI === void 0 ? 0.0 : _param_avgCPI, _param_acceptedTotal = param.acceptedTotal, acceptedTotal = _param_acceptedTotal === void 0 ? 0.0 : _param_acceptedTotal, acceptedIdsByCPI = param.acceptedIdsByCPI, rejectedIdsByCPI = param.rejectedIdsByCPI, _param_rejectedTotal = param.rejectedTotal, rejectedTotal = _param_rejectedTotal === void 0 ? 0.0 : _param_rejectedTotal;
    var campaignSummary = React.useMemo(function() {
        return /*#__PURE__*/ React.createElement("div", {
            className: "campaign-summary spacing-top"
        }, /*#__PURE__*/ React.createElement("ul", null, /*#__PURE__*/ React.createElement("li", {
            "data-testid": "accepted-total"
        }, /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("strong", null, "Accepted total: "), "$", acceptedTotal.toFixed(2))), !!avgCPI && /*#__PURE__*/ React.createElement("li", {
            "data-testid": "average-cpi"
        }, /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("strong", null, "Average CPI: "), "$", avgCPI.toFixed(2))), acceptedTotal > 0 && /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("ul", {
            className: "completes-summary"
        }, summaryFromIdsByCPI(acceptedIdsByCPI, "Completes at")))));
    }, [
        avgCPI,
        acceptedIdsByCPI,
        acceptedTotal
    ]);
    var rejectedSummary = React.useMemo(function() {
        return /*#__PURE__*/ React.createElement("div", {
            className: "rejected-summary spacing-top"
        }, /*#__PURE__*/ React.createElement("ul", null, /*#__PURE__*/ React.createElement("li", {
            "data-testid": "rejected-total"
        }, /*#__PURE__*/ React.createElement("strong", null, "Rejected total: "), "$", rejectedTotal.toFixed(2)), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("ul", {
            className: "completes-summary"
        }, summaryFromIdsByCPI(rejectedIdsByCPI, "Rejects at")))));
    }, [
        rejectedTotal,
        rejectedIdsByCPI
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "spacing-top"
    }, /*#__PURE__*/ React.createElement("strong", null, "Final CPI: "), /*#__PURE__*/ React.createElement("span", {
        "data-testid": "final-cpi"
    }, "$", cpi.toFixed(2))), acceptedTotal > 0 && rejectedSummary, campaignSummary);
};
